import React, { useEffect } from 'react';
const getDate = (date) => {
    let formattedDate;
    let dateObject = new Date(date);
    let options = {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    };
    if (navigator.userAgent.indexOf('iPhone') > -1) {
        dateObject = new Date(date.replace(/-/g, "/"));
    }
    formattedDate = dateObject.toLocaleDateString(navigator.language, options);
    formattedDate = formattedDate.replace(/ /g, '-').replace(/,/g, '');
    return formattedDate;
};
function getMonthDays(year, month) {
    const lastDay = new Date(year, month, 0);
    return lastDay.getDate();
}
function GraphDataTable({ type, simObj, setSimObj }) {
    let CostQualityData;
    let FailureData;
    switch (type) {
        case "monthly":

            CostQualityData = simObj?.graphdata?.filter((data, index) => {
                if (data.statemonth === simObj?.laststate?.statemonth) {
                    return true;
                }
            });
            CostQualityData = (CostQualityData != undefined ? CostQualityData : []).map((data) => {
                return {
                    x: data.stateday,
                    y: data.cost,
                    date: getDate(data.currentRampDate),
                    cost: Math.round(data.cost),
                    costOfInternalFailures: Math.round(data.costOfInternalFailures),
                    costOfExternalFailures: data.conceptualCostOfExternalFailures,
                    costOfPreventiveInvestment: data.costOfPreventiveInvestment,
                    costOfAppraisal: data.costOfAssessmentInvestment,
                    costOfotherInvestment: data.costOfRedHerringInvestment,
                    revenue: data.revenue,
                }
            });
              FailureData = simObj?.graphdata?.filter((data, index) => {
                if (data?.statemonth === simObj?.laststate?.statemonth) {
                  return true;
                }
              });
              FailureData = (FailureData != undefined ? FailureData : []).map((data) => {
                return {
                  x: data.stateday,
                  y: data.failureRate,
                  date: getDate(data.currentRampDate),
                  externalFailureRate: data.externalFailureRate,
                  internalFailureRate: data.internalFailureRate
    
                }
              });
            break;
        case "quarterly":
            CostQualityData = simObj?.graphdata?.filter((data, index) => {
                if (data.statemonth >= simObj?.laststate?.statemonth - 2) {
                    return true;
                }
            });
            CostQualityData = (CostQualityData != undefined ? CostQualityData : []).map((data) => {
                return {
                    x: ((data.statemonth - 1) + (data.stateday / getMonthDays(simObj?.laststate?.stateyear, data.statemonth))).toFixed(2),
                    y: data.cost,
                    cost: Math.round(data.cost),
                    date: getDate(data.currentRampDate),
                    costOfInternalFailures: Math.round(data.costOfInternalFailures),
                    costOfExternalFailures: data.conceptualCostOfExternalFailures,
                    costOfPreventiveInvestment: data.costOfPreventiveInvestment,
                    costOfAppraisal: data.costOfAssessmentInvestment,
                    costOfotherInvestment: data.costOfRedHerringInvestment,
                    revenue: data.revenue,
                }
            });
              FailureData = simObj?.graphdata?.filter((data, index) => {
                if (data.statemonth >= simObj?.laststate?.statemonth - 2) {
                  return true;
                }
              });
              FailureData = (FailureData != undefined ? FailureData : []).map((data) => {
                return {
                  x: (data.statemonth - 1) + (data.stateday / getMonthDays(simObj?.laststate?.stateyear, data.statemonth)),
                  y: data.failureRate,
                  date: getDate(data.currentRampDate),
                  externalFailureRate: data.externalFailureRate,
                  internalFailureRate: data.internalFailureRate
                }
              });
            break;
        case "yearly":
            CostQualityData = simObj?.graphdata;
            CostQualityData = (CostQualityData != undefined ? CostQualityData : []).map((data) => {
                return {
                    x: ((data.statemonth - 1) + (data.stateday / getMonthDays(simObj?.laststate?.stateyear, data.statemonth))).toFixed(2),
                    y: data.cost,
                    cost: Math.round(data.cost),
                    date: getDate(data.currentRampDate),
                    costOfInternalFailures: Math.round(data.costOfInternalFailures),
                    costOfExternalFailures: data.conceptualCostOfExternalFailures,
                    costOfPreventiveInvestment: data.costOfPreventiveInvestment,
                    costOfAppraisal: data.costOfAssessmentInvestment,
                    costOfotherInvestment: data.costOfRedHerringInvestment,
                    revenue: data.revenue,
                }
            });
            FailureData = simObj?.graphdata;
            FailureData = (FailureData != undefined ? FailureData : []).map((data) => {
              return {
                x: (data?.statemonth - 1) + (data.stateday / getMonthDays(simObj?.laststate?.stateyear, data?.statemonth)),
                y: data.failureRate,
                date: getDate(data.currentRampDate),
                externalFailureRate: data.externalFailureRate,
                internalFailureRate: data.internalFailureRate
              }
            });
            break;
        default:
            CostQualityData = [];
            FailureData=[];
            break;
    }


    return (
        <div className="header-container">
            <header class="header main-header"><div class="container"><h1 class="title" aria-hidden="false" tabindex="-1">Quality Management Simulation Graph Data as of  {getDate(simObj?.laststate?.currentRampDate)}</h1></div></header>
            <div className="MainDiv">
                <div className="MainDivChild">
                    <div class="jumbotron text-center bg-sky">
                        <h3 className="headingh3">Revenue/ Cost Of Quality Graph Data</h3>
                    </div>

                    <div className="container">

                        <table id="RevenueGraphData" class="display cell-border">
                            <thead>
                                <tr>
                                    <th>Day</th>
                                    <th>Cost</th>
                                    <th>Internal Failure Cost</th>
                                    <th>External Failure Cost</th>
                                    <th>Preventive Investment</th>
                                    <th>Appraisal Investment</th>
                                    <th>Other Investments</th>
                                    <th>Revenue</th>

                                </tr>
                            </thead>
                            <tbody>
                                {CostQualityData.map((data, index) => (
                                    <tr key={index}>
                                        <td>{data.date}</td>
                                        <td>${data.cost}</td>
                                        <td>${data.costOfInternalFailures}</td>
                                        <td>${data.costOfExternalFailures}</td>
                                        <td>${data.costOfPreventiveInvestment}</td>
                                        <td>${data.costOfAppraisal}</td>
                                        <td>${data.costOfotherInvestment}</td>
                                        <td>${data.revenue}</td>


                                    </tr>
                                ))}
                            </tbody>

                        </table>


                    </div>
                    <p></p>
                    <div className="container">

                        <div class="jumbotron text-center bg-sky">
                            <h3 className="headingh3">Failure Rate Graph Data</h3>
                        </div>
                        <table id="FailureGraphData" class="display cell-border">
                            <thead>
                                <tr>
                                    <th>Day</th>
                                    <th>Internal Failure Rate</th>
                                    <th>External Failure Rate</th>
                                </tr>
                            </thead>
                            <tbody>
                                {FailureData.map((data, index) => (
                                    <tr key={index}>
                                        <td>{data.date}</td>
                                        <td>{data.internalFailureRate}%</td>
                                        <td>{data.externalFailureRate}%</td>
                                    </tr>
                                ))}
                            </tbody>

                        </table>

                    </div>
                </div>
            </div>
            <footer className="footer">
                <div className="container">

                    <span className="copyright-text">Copyright &#169;2023 </span>
                    <ul className="footer-links">
                        <li className="listitem"><a href="https://www.pearson.com/en-us.html" target='_blank'>Pearson Education</a></li>
                        <li className="listitem"><span>&nbsp;|&nbsp;</span></li>
                        <li className="listitem"><a href="https://loginstatic.pearson.com/html/PearsonPrivacyPolicy.html?" target='_blank'>Privacy Policy</a></li>
                    </ul>
                </div>

            </footer>

        </div>

    );
}

export default GraphDataTable;
